// A call of the `(payload, resolve, reject)` shape of server/index.js, as a
// promise.
export const callApi = (method, payload) =>
  new Promise((resolve, reject) => method(payload, resolve, reject));

export const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// The same object without one of its keys.
export const omitKey = (object, key) => {
  const { [key]: _removed, ...rest } = object;
  return rest;
};
